<template>
<div class="align-center-main">
  <!--  会议室列表  -->
  <ul class="meeting_room" v-loading="loading" v-if="meetingRoomList.length">
    <li class="boxShadow" v-for="(item, index) in meetingRoomList" :key="index" @click="jumpDetails(item.id)">
      <img :src="item.roomPic" alt="">
      <div class="content">
        <h3 class="textOver">{{ item.roomName }}</h3>
        <!-- <h4 class="textOver bold">价格：{{ item.minFee / 100 | PriceFilter }} 元起</h4> -->
        <p class="textOver num">容量：{{ item.capacityNum }} 人</p>
        <p>其他设备：{{ item.roomTag | roomTagFilter }}</p>
        <div class="myButton button" @click.stop="$router.push({ path: `/navigator/businessPlatform/letMeetingRoom/${$route.params.serviceId}`, query: { id : item.id}})">预订</div>
      </div>
    </li>
  </ul>
  <div class='pages main-pagination' v-if="pageTotal > 6">
    <el-pagination :page-size="6" layout="prev, pager, next, jumper" background @current-change="handleCurrentChange" :total="pageTotal"></el-pagination>
  </div>

  <Nothing v-if="!meetingRoomList && !loading"></Nothing>

</div>
</template>


<script>
import {
  mapGetters
} from 'vuex';
// import BusinessList from '../components/BusinessList';

export default {
  data() {
    return {
      pageIndex: 1,
      pageTotal: 0,
      loading: true,
      meetingRoomList: [],
    }
  },
  methods: {
    jumpDetails(index) {
      this.$router.push({
        path: `/navigator/businessPlatform/meetingRoomDetail/${this.$route.params.serviceId}/${index}`
      })
    },
    getList() { // 获取服务列表
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/meeting/room/info/list`, {
        parkId: this.currentParkId,
        currPage: this.pageIndex,
        pageRows: 6,
      }).then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          this.meetingRoomList = res.resData.pageList || [];
          this.pageTotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
        }
      });
    },
    handleCurrentChange(val) { // 改变页数
      this.pageIndex = val;
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters(['currentParkId']),
  },
  filters: {
    roomTagFilter(val) {
      if (val == '') {
        return '暂无详情';
      } else {
        return val.replace(/,/g, ' | ');
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.fullPath == '/navigator/businessPlatform/businessNav') {
      this.$router.push('/index')
    }
    next()
  },
}
</script>

<style lang="scss" scoped>
.el-breadcrumb {
  margin: 20px 0;
}

// 会议室
.meeting_room {
  li {
    width: 100%;
    height: 300px;
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 4px;
    display: flex;
    cursor: pointer;
    img {
      width: 535px;
      height: 100%;
      border-radius: 4px 0 0 4px;
    }
    .content {
      flex: 1;
      padding-left: 30px;
      .bold {
        font-weight: bold;
        padding-top: 10px;
        margin-bottom: 16px;
      }
      .rate {
        // line-height: 32px;
        // float: left;
        // padding-right: 100px;
        span {
          color: #666;
          margin-right: -103px;
          margin-top: -26px;
          float: right;
        }
      }
      h3 {
        width: 600px;
        margin-top: 32px;
        margin-bottom: 20px;
        font-size: 30px;
        line-height: 30px;
      }
      h4 {
        width: 600px;
        font-size: 16px;
        color: #de2c32;
        margin-bottom: 25px;
        margin-right: 10px;
      }
      .num {
        width: 600px;
      }
      p {
        color: #666;
        font-size: 14px;
        line-height: 25px;
        margin-right: 10px;
        &:last-of-type {
          height: 50px;
          overflow: hidden;
        }
      }
    }
  }
}

.button {
  margin-top: 25px;
  letter-spacing: 2px;
}

.pages {
  margin-top: 60px;
  margin-bottom: 60px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/businessPlatform/child/MeetingRoom.vue